import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import AdminLayout from './components/layout/AdminLayout';
import ProtectedRoute from './components/auth/ProtectedRoute';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Members from './pages/Members';
import Finance from './pages/Finance';
import Rewards from './pages/Rewards';
import Library from './pages/Library';
import Communication from './pages/Communication';
import Community from './pages/Community';
import CommunitySupport from './pages/CommunitySupport';
import Marketplace from './pages/Marketplace';
import Boutique from './pages/Boutique';
import Security from './pages/Security';
import Settings from './pages/Settings';
import Administrators from './pages/Administrators';

export default function App() {
  return (
    <Router>
      <Routes>
        {/* Route publique */}
        <Route path="/login" element={<Login />} />

        {/* Portail admin protégé : ProtectedRoute vérifie le token puis GET /admin/me avant d'autoriser l'accès */}
        <Route element={<ProtectedRoute />}>
          <Route path="/" element={<AdminLayout />}>
            <Route index element={<Dashboard />} />
            <Route path="members" element={<Members />} />
            <Route path="finance" element={<Finance />} />
            <Route path="rewards" element={<Rewards />} />
            <Route path="library" element={<Library />} />
            <Route path="communication" element={<Communication />} />
            <Route path="community" element={<Community />} />
            <Route path="community/support" element={<CommunitySupport />} />
            <Route path="marketplace" element={<Marketplace />} />
            <Route path="boutique" element={<Boutique />} />
            <Route path="security" element={<Security />} />
            <Route path="settings" element={<Settings />} />
            <Route path="administrators" element={<Administrators />} />

            {/* Redirection fallback */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Route>
      </Routes>
    </Router>
  );
}